import { render, staticRenderFns } from "./Trends_Virtual.vue?vue&type=template&id=be433ddc"
import script from "./Trends_Virtual.vue?vue&type=script&lang=js"
export * from "./Trends_Virtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports